var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    width: 39.9991,
    height: 39.9993,
    rx: 19.9995,
    fill: "#D4ADF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2449 12C20.779 12.0029 22.1153 12.0159 23.5351 12.0727L24.0385 12.0947C25.468 12.1624 26.8963 12.278 27.6047 12.4755C28.5496 12.741 29.2923 13.5155 29.5433 14.4973C29.943 16.0564 29.993 19.0994 29.9992 19.8358L30.0001 19.9884V19.9991C30.0001 19.9991 30.0001 20.0028 30.0001 20.0099L29.9992 20.1625C29.993 20.8989 29.943 23.9419 29.5433 25.501C29.2888 26.4864 28.5461 27.261 27.6047 27.5228C26.8963 27.7203 25.468 27.8359 24.0385 27.9036L23.5351 27.9255C22.1153 27.9824 20.779 27.9953 20.2449 27.9983L20.0105 27.9991H20.0001C20.0001 27.9991 19.9966 27.9991 19.9897 27.9991L19.7555 27.9983C18.6251 27.9921 13.8987 27.941 12.3955 27.5228C11.4506 27.2573 10.7079 26.4828 10.4568 25.501C10.0572 23.9419 10.0072 20.8989 10.001 20.1625V19.8358C10.0072 19.0994 10.0572 16.0564 10.4568 14.4973C10.7114 13.5119 11.4541 12.7373 12.3955 12.4755C13.8987 12.0572 18.6251 12.0062 19.7555 12H20.2449ZM18.0001 16.4991V23.4991L24.0001 19.9991L18.0001 16.4991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6ffb859e922e81192f1821a1bea06629.svg";
export { ForwardRef as ReactComponent };